import { mapboxApiServiceClient } from "./AxiosInstance";

const METROPOLITAN_FRANCE_BBOX = [-5.009766, 41.211722, 9.887695, 51.151786];
export default {
  searchAutocompleteAPI: function(searchText) {
    const url =
      "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
      searchText +
      ".json";
    return mapboxApiServiceClient.get(url, {
      params: {
        access_token: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
        autocomplete: true,
        limit: 5,
        language: "fr",
        country: "fr",
        bbox: METROPOLITAN_FRANCE_BBOX,
        types: [
          "country",
          "region",
          "district",
          "place",
          "locality",
          "neighborhood",
          "address",
          "poi"
        ]
      }
    });
  },
  shareAutocompleteAPI: function(searchText) {
    const url =
      "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
      searchText +
      ".json";
    return mapboxApiServiceClient.get(url, {
      params: {
        access_token: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
        autocomplete: true,
        limit: 5,
        language: "fr",
        country: "fr",
        bbox: METROPOLITAN_FRANCE_BBOX,
        types: ["place", "locality", "neighborhood", "address", "poi"]
      }
    });
  }
};
